export default __webpack_public_path__ + "static/media/standard_04.42bd16d0.png";